// src/components/Common/SearchBar.jsx
import React from "react";
import { TextField, Box, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const BRAND_BLUE = "#00336C";
const BRAND_GREEN = "#648315";

function SearchBar({
  value,
  onChange,
  placeholder = "Search...",
  maxWidth = 1450,
  onEnter = null,
  containerSx = {},
  wrapperSx = {},
  inputRef = null,
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (typeof onEnter === "function") {
        onEnter();
      }
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", ...containerSx }}>
      <Box sx={{ width: "100%", maxWidth, ...wrapperSx }}>
        <TextField
          inputRef={inputRef}
          placeholder={placeholder}
          variant="outlined"
          fullWidth
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: BRAND_GREEN, fontSize: 20, opacity: 0.85 }} />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              backgroundColor: "#eef2f8",
              transition: "background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
              "& fieldset": {
                borderColor: "rgba(0,51,108,0.14)",
                borderWidth: 1.5,
              },
              "&:hover": {
                backgroundColor: "#e6edf6",
                "& fieldset": {
                  borderColor: "rgba(0,51,108,0.28)",
                },
              },
              "&.Mui-focused": {
                backgroundColor: "#ffffff",
                boxShadow: "0 0 0 3px rgba(0,51,108,0.1), 0 2px 8px rgba(0,51,108,0.08)",
                "& fieldset": {
                  borderColor: BRAND_BLUE,
                  borderWidth: 1.5,
                },
              },
            },
            "& input": {
              fontSize: "0.95rem",
              fontWeight: 500,
              color: "#1a2e4a",
              py: 1.25,
              "&::placeholder": {
                color: "#7b90b2",
                opacity: 1,
                fontWeight: 400,
              },
            },
            "& .MuiInputAdornment-root": {
              ml: 0.5,
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default React.memo(SearchBar);
